"use strict";

exports.__esModule = true;
exports.ReportURLFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _URLFilter = require("../../Core/URLFilter");
var _Time = require("../../Time");
var _timeDefinitions = require("../../timeDefinitions");
var _dec, _class, _ReportURLFilter;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * URL filter for reports.
 */
var ReportURLFilter = exports.ReportURLFilter = (_dec = _Time.TimeContext.withContext, _dec(_class = (_ReportURLFilter = /*#__PURE__*/function (_Component) {
  function ReportURLFilter() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportURLFilter, _Component);
  var _proto = ReportURLFilter.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      time = _this$props.time,
      timeRangeKind = _this$props.timeRangeKind;
    var start;
    var end = new Date(time.currentWorkday.interval.endMillis).toISOString();
    if (timeRangeKind === "multiDay") {
      start = new Date(time.currentWorkday.interval.startMillis - _timeDefinitions.WEEK_IN_MILLIS).toISOString();
    } else {
      start = new Date(time.currentWorkday.interval.startMillis).toISOString();
    }
    return /*#__PURE__*/_react["default"].createElement(_URLFilter.URLFilterController, {
      replace: true,
      params: {
        period: {
          "default": start + "/" + end
        },
        device: {
          multiple: true,
          "default": []
        },
        deviceTypes: {
          multiple: true,
          "default": []
        },
        tags: {
          multiple: true,
          "default": []
        },
        chartFilteredActivities: {
          multiple: true,
          "default": []
        }
      }
    }, this.props.children);
  };
  return ReportURLFilter;
}(_react.Component), _ReportURLFilter.defaultProps = {
  time: undefined
}, _ReportURLFilter)) || _class);